import { createAsyncComponentWithReducer } from '../../shared';
import type * as ReactType from 'react';
import type { Store } from 'redux';
import { LazyModule } from 'owa-bundling';

const lazyModule = new LazyModule(() => import('./lazyImportContactsDialogAsync'));

export const ImportContactsDialogAsync = createAsyncComponentWithReducer(async () => {
    const { packageStateKey, reducer, component } = await lazyModule.import();
    return { packageStateKey, reducer, component };
}) as ReactType.ComponentType<{ store: Store<{}> }>;
